export const getFileNameLink = (url) => url?.split('/').pop().split('#')[0].split('?')[0];